/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Buttons, NotificationModal } from 'components';
import * as S from './PublisherPayments.styled';

export const WireDetails = ({
  wireFormFields,
  isWireConfigured,
  onHandleDeletePayment,
  data,
  onSetIsWireOpen,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!data || !isWireConfigured)
    return (
      <>
        <S.SmallText>
          Transfer fees will be included in every transaction.
          <br />
          For detailed information, please contact{' '}
          <S.ExternalLink
            href='mailto:payments@appnext.com.'
            target='_blank'
            rel='noopener nofollow'
          >
            payments@appnext.com.
          </S.ExternalLink>
        </S.SmallText>
        <Buttons.SecondaryNormal
          id='set_up_wire'
          style={{ marginTop: 'auto' }}
          onClick={() => onSetIsWireOpen(true)}
        >
          Set Up
        </Buttons.SecondaryNormal>
      </>
    );

  return (
    <>
      {isModalOpen ? (
        <NotificationModal
          title='Allert'
          id='confirm_delete_wire'
          iconType={NotificationModal.iconTypes.error}
          iconSign='?'
          onConfirm={() => onHandleDeletePayment(1)}
          onCancel={() => setIsModalOpen(false)}
          confirmBtnType={NotificationModal.btnTypes.DestructiveNormal}
          confirmBtnText='Delete'
          cancelBtnType={NotificationModal.btnTypes.SecondaryNormal}
          cancelBtnText='Cancel'
        >
          Delete Wire Details?
        </NotificationModal>
      ) : null}
      <S.SmallText>Bank Details</S.SmallText>
      {wireFormFields.map((item, ind) => (
        <S.WireText key={ind}>
          <S.SubHeading>{item.title}:</S.SubHeading>
          <span>{data?.[item.id]}</span>
        </S.WireText>
      ))}
      <S.ButtonsWrap>
        <Buttons.SecondaryNormal
          style={{ marginTop: '16px' }}
          id='change_wire'
          onClick={() => onSetIsWireOpen(true)}
        >
          Change
        </Buttons.SecondaryNormal>
        <Buttons.SecondaryNormal
          style={{ margin: '16px 0 0 24px' }}
          id='delete_wire'
          onClick={() => setIsModalOpen(true)}
        >
          Delete
        </Buttons.SecondaryNormal>
      </S.ButtonsWrap>
    </>
  );
};
